<template>
  <section>


<div class="page">
  <div>
    <h2>Using one ToTok account on multiple phones, or with multiple phone numbers</h2>
    <p>
      Your ToTok account can only be verified with one number on one device. If you have a dual SIM phone, please note
      that you still must choose one number to verify with ToTok. There is no option to have a ToTok account with two
      phone numbers.
    </p>
    <p>
      If you attempt to frequently switch your ToTok account between different devices, at a certain point, you may be
      blocked from re-verifying your account. Please don't repeatedly switch between different devices and numbers.
    </p>
  </div>
</div>

  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {
    };
  },
  computed: {},
  methods: {}
}
</script>